import { render } from "./WCSideMenuCollapsibleTemplate.vue?vue&type=template&id=671ed3db&scoped=true"
import script from "./WCSideMenuCollapsibleTemplate.vue?vue&type=script&lang=js"
export * from "./WCSideMenuCollapsibleTemplate.vue?vue&type=script&lang=js"

import "./WCSideMenuCollapsibleTemplate.vue?vue&type=style&index=0&id=671ed3db&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671ed3db"]])

export default __exports__